import { withObjectionFaqs } from "@/lib/faqs";
import { createFileRoute } from "@tanstack/react-router";
import { ServicePageLayout } from "@/components/ServicePageLayout";
import { SERVICE_PAGES } from "@/lib/service-content";
import { buildService, buildFaqPage, buildBreadcrumbs, buildLocalBusiness } from "@/components/SchemaJsonLd";

const data = SERVICE_PAGES["grind-and-seal-concrete"];

export const Route = createFileRoute("/services/grind-and-seal-concrete")({
  head: () => ({
    meta: [
      { title: "Grind & Seal Concrete Floors in the Calgary region | MLC Epoxy Floors" },
      { name: "description", content: "Polished concrete grind and seal floor coatings — natural concrete look sealed with polyaspartic. Cost-effective premium floors in the Calgary region." },
      { property: "og:title", content: "Grind & Seal Concrete | MLC Epoxy Floors" },
      { property: "og:description", content: "Polished concrete sealed with high-performance polyaspartic for a durable, natural finish." },
      { property: "og:url", content: "/services/grind-and-seal-concrete" },
    ],
    links: [{ rel: "canonical", href: "/services/grind-and-seal-concrete" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(buildLocalBusiness()) },
      { type: "application/ld+json", children: JSON.stringify(buildService(data.name, data.slug, data.intro)) },
      { type: "application/ld+json", children: JSON.stringify(buildFaqPage(withObjectionFaqs(data.faqs))) },
      { type: "application/ld+json", children: JSON.stringify(buildBreadcrumbs([
        { name: "Home", href: "/" }, { name: "Services", href: "/services" }, { name: data.name, href: `/services/${data.slug}` }
      ])) },
    ],
  }),
  component: () => <ServicePageLayout {...data} />,
});
